<template>
	<!-- 中奖弹窗 -->
	<el-dialog fullscreen :show-close="false" custom-class="adtips" v-model="visible" title="" @close="cancel">
		<div class="rewardsBox" :class="{'isads':isAd}">
			<div class="titles"><img src="/iaa/rewardsTitle.png"></div>
			<div class="list"><slot></slot></div>
			<div class="close" @click="cancel">确定</div>
		</div>
	</el-dialog>
</template>

<script setup>
	import { getCurrentInstance, reactive, ref, onMounted, defineProps, defineEmits, computed } from 'vue'
	
	const { proxy } = getCurrentInstance();
	const props = defineProps({
		showVisible: {
			type: Boolean,
			default: false
		},
		showTitle: {
			type: String,
			default: ''
		},
		isAds: {
			type: Boolean,
			default: false
		}
	})
	const emits = defineEmits(['cancel'])
	const cancel = () => {
		emits('cancel')
	}
	const visible = computed(() => {
		return props.showVisible
	})
	const title = computed(() => {
		return props.showTitle
	})
	const isAd = computed(() => {
		return props.isAds
	})
</script>

<style lang="less" scoped>
	.adtips{
		@keyframes fadeIn {
		  from { opacity: 0; } /* 动画开始时透明度为0 */
		  to { opacity: 1; } /* 动画结束时透明度为1 */
		}
		
		.rewardsBox{
			width: 30rem;height: 30rem;padding: 1rem;box-sizing: border-box;
			background: url('/iaa/popupBgRewards.png') no-repeat center;
			background-size: 100%;color: #FFFE61;
			position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);
			.titles{
				width: 80%;margin: -10% auto 0;
				img{
					width: 100%;
				}
			}
			.list{
				height: 68%;width: 100%;
				opacity: 0;animation: fadeIn 2s ease-in-out forwards;
			}
			.close{
				width: 9rem;height: 2.8rem;text-align: center;color: #fff;font-weight: 500;line-height: 2.8rem;
				background: url('/iaa/popupConfirmbg.png') no-repeat center;
				background-size: 100%;
				position: absolute;bottom: 0;left: 50%;transform: translate(-50%,0);
			}
			
		}
	}
</style>